import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { usePage } from '@inertiajs/react';
import { PageProps } from '@/types';
import BaseLayout from './BaseLayout';

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const page = usePage<PageProps>();
  const { navigation, footer, app_name } = page.props;

  return (
    <BaseLayout>
    <div className="flex min-h-screen flex-col text-black">
      <NavBar navigation={navigation} footer={footer} app_name={app_name} />
      <main className="flex-1">
        {children}
      </main>
      <Footer footer={footer} />
    </div>
    </BaseLayout>
  );
} 